module.exports = __webpack_public_path__ + "static/img/bg93.32ad5ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/year2023/bg93.png
// module id = x5by
// module chunks = 0